var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('canvas-animation'),_c('div',{attrs:{"id":"canvas-overlay"}},[_c('h1',{attrs:{"id":"blurb"}},[_vm._v(" "+_vm._s(_vm.blurbs[_vm.currentBlurbIndex])+" ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }